import { colors } from 'ic-snacks'

export const CHART_PADDING_RIGHT = 40
const AXIS_FONT_SIZE = 16
const AXIS_FONT_WEIGHT = 200
const AXIS_FONT_COLOR = colors.GRAY_46

const sharedAxisTickLabelsStyle = {
  fontWeight: AXIS_FONT_WEIGHT,
  fontSize: AXIS_FONT_SIZE,
  fill: AXIS_FONT_COLOR,
  fontFamily: 'inherit',
}

const fontFamily = "'Eina 01', Helvetica Neue, Arial, sans-serif"

export const chartContainerStyle = {
  parent: {
    fontFamily,
  },
}

export const verticalAxisStyle = {
  grid: { stroke: colors.GRAY_93 },
  axis: { stroke: colors.WHITE },
  tickLabels: {
    verticalAnchor: 'middle',
    textAnchor: 'start',
    padding: 60,
    ...sharedAxisTickLabelsStyle,
  },
}

export const baseHorizontalAxisStyle = {
  axis: { stroke: colors.GRAY_74 },
  tickLabels: {
    padding: 32,
    verticalAnchor: 'end',
    ...sharedAxisTickLabelsStyle,
  },
}

export const horizontalAxisStyle = (domainStart: number, domainEnd: number) => ({
  tickLabels: {
    ...baseHorizontalAxisStyle.tickLabels,
    fontSize: (t: number) => (t > domainStart && t < domainEnd ? AXIS_FONT_SIZE : 0),
  },
  axis: { ...baseHorizontalAxisStyle.axis },
})

export const tooltipFlyoutStyle = {
  fill: colors.WHITE,
  stroke: colors.GRAY_46,
  fontFamily: 'inherit',
  padding: 10,
}
